import React from 'react';
import styles from './Spinner.module.css';
import Overlay from './Overlay';

const AIEduSpinner = () => {
  return (
    <Overlay className={styles.content_overlay}>
      <div className={styles.spinner_container}>
        <div className={styles.loading_spinner}></div>
      </div>
    </Overlay>
  );
};

export default AIEduSpinner;
